import { render, staticRenderFns } from "./GainLoseDisplayer.vue?vue&type=template&id=a5d46164&scoped=true&"
import script from "./GainLoseDisplayer.vue?vue&type=script&lang=js&"
export * from "./GainLoseDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./GainLoseDisplayer.vue?vue&type=style&index=0&id=a5d46164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d46164",
  null
  
)

export default component.exports